/* eslint-disable @typescript-eslint/naming-convention */
import { ProductDetailsPage } from './product-details-page';
import { HomePage } from './home-page';

export type { PreviewData } from './preview.types';

export const Preview = {
  ProductDetailsPage,
  HomePage,
};
